export default {
  header: {
    review_us: 'Oceń nas w Google',
    upload: 'Prześlij recenzję Google',
    not_now: 'Nie teraz',
  },
  steps: {
    how_it_works: 'Jak to działa',
    step_1: {
      title: 'Krok',
      description: 'Napisz recenzję o {{name}} w Google',
    },
    step_2: {
      title: 'Krok',
      description: 'Prześlij zrzut ekranu opublikowanej recenzji (patrz przykład poniżej)',
    },
  },
  buttons: {
    upload_screenshot: 'Prześlij zrzut ekranu',
    leave_google_review: 'Zostaw recenzję Google',
    submit_screenshot: 'Wyślij zrzut ekranu',
    return: 'Wstecz',
  },
  enter_name: {
    title: 'Imię podane w recenzji Google',
    place_holder: 'Wprowadź imię',
  },
  screenshot_uploaded: {
    title: 'Zrzut ekranu przesłany',
    description: 'Przewiń w dół, aby zobaczyć pełny zrzut ekranu',
  },
  loading: {
    processing: 'Twoja recenzja jest weryfikowana',
  },
  error_messages: {
    upload_failed: 'Nie udało się przesłać zrzutu ekranu. Spróbuj ponownie.',
    review_already_uploaded:
      'Wygląda na to, że zrzut ekranu recenzji Google został już przesłany. Za recenzję Google można otrzymać nagrodę tylko raz 😊',
    name_missing: {
      description: 'Podaj imię użyte w recenzji Google, abyśmy mogli dopasować Twoje dane.',
      button: {
        title: 'OK',
      },
    },
  },
};
